/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'app/components/common/Loading.jsx';

class LinkPreview extends React.Component {
    render() {
        let media = '',
            constants = this.props.app.config.constants,
            removeLink = null;

        if (!this.props.loading) {
            if (parseInt(this.props.serviceType) === constants.POST_SVC_TWITTER) {
                if (this.props.previewData.twitter_media !== undefined) {
                    media = (this.props.previewData.twitter_media[0] !== undefined) ? this.props.previewData.twitter_media[0].link : '';
                }
                // plot twist! twitter media might be empty
                if (!media && this.props.previewData.media !== undefined) {
                    media = (this.props.previewData.media[0] !== undefined) ? this.props.previewData.media[0] : '';
                }
            } else {
                if (this.props.previewData.media !== undefined) {
                    media = (this.props.previewData.media[0] !== undefined) ? this.props.previewData.media[0] : '';
                }
            }
        }

        if ([constants.POST_SVC_TWITTER, constants.POST_SVC_REDDIT, constants.POST_SVC_BLUESKY].indexOf(parseInt(this.props.serviceType)) === -1) {
            removeLink = (
                <div className="remove-link" role="button" aria-label="Remove Shared Link" onClick={this.props.removeLink} data-servicetype={this.props.serviceType}>
                    <i className="fa fa-times-circle"></i>
                </div>
            );
        } else if ([constants.POST_SVC_TWITTER, constants.POST_SVC_BLUESKY].indexOf(parseInt(this.props.serviceType)) !== -1 && this.props.linkInMessage === false) {
            removeLink = (
                <div className="remove-link" role="button" aria-label="Remove Shared Link" onClick={this.props.removeLink} data-servicetype={this.props.serviceType}>
                    <i className="fa fa-times-circle"></i>
                </div>
            );
        }

        return (
            <div className={`pt-link-preview ${this.props.context}`}>
                {(this.props.loading) ? (
                    <Loading/>
                ) : (
                    <div className="pt-link-wrapper">
                        {removeLink}
                        <div className="link-media">
                            {(media) ? (
                                <img src={media}/>
                            ) : null}
                        </div>
                        <div className="link-content">
                            <div className="link-headline">{this.props.previewData.title}</div>
                            <div className="link-synopsis">{this.props.previewData.summary}</div>
                            <div className="link-url">{this.props.previewData.url}</div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

LinkPreview.displayName = "LinkPreview";

LinkPreview.propTypes = {
    previewData: PropTypes.object,
    loading: PropTypes.bool,
    context: PropTypes.string,
    serviceType: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    linkInMessage: PropTypes.bool
};

LinkPreview.defaultProps = {
    previewData: {},
    loading: true,
    context: 'shared',
    serviceType: 0,
    linkInMessage: true
};

export default LinkPreview;
